import React from "react";

import LocationCityIcon from "@mui/icons-material/LocationCity";
import { Stack, Typography } from "@mui/material";
import { WorkspaceFolderCloseIcon } from "assets/material-custom-icons";

const iconSx = { fill: "#0A3142", fontSize: 20 };
const titleSx = {
  color: "#0a3142",
  fontWeight: 700,
  fontSize: 16,
  lineHeight: "24px"
};

export interface MetadataHeadProps {
  title: string;
  icon: "deal" | "folder";
}

export const Head: React.FC<MetadataHeadProps> = ({ title, icon }) => {
  const IconComponent = icon === "deal" ? LocationCityIcon : WorkspaceFolderCloseIcon;

  return (
    <Stack direction="row" alignItems="center" gap="10px" sx={{ width: "100%" }}>
      <IconComponent sx={iconSx} />
      <Typography noWrap sx={titleSx}>
        {title}
      </Typography>
    </Stack>
  );
};
